export default __webpack_public_path__ + "static/media/shirt12.12bd4d0f.jpeg";